"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cosmos = void 0;
/* eslint-disable */
const _9 = __importStar(require("./bank/v1beta1/bank"));
const _10 = __importStar(require("./bank/v1beta1/genesis"));
const _11 = __importStar(require("./bank/v1beta1/query"));
const _12 = __importStar(require("./bank/v1beta1/tx"));
const _13 = __importStar(require("./base/abci/v1beta1/abci"));
const _14 = __importStar(require("./base/query/v1beta1/pagination"));
const _15 = __importStar(require("./base/v1beta1/coin"));
const _16 = __importStar(require("./crypto/ed25519/keys"));
const _17 = __importStar(require("./crypto/multisig/keys"));
const _18 = __importStar(require("./crypto/secp256k1/keys"));
const _19 = __importStar(require("./tx/signing/v1beta1/signing"));
const _20 = __importStar(require("./tx/v1beta1/service"));
const _21 = __importStar(require("./tx/v1beta1/tx"));
const _63 = __importStar(require("./bank/v1beta1/tx.amino"));
const _64 = __importStar(require("./bank/v1beta1/tx.registry"));
const _65 = __importStar(require("./bank/v1beta1/query.rpc.Query"));
const _66 = __importStar(require("./tx/v1beta1/service.rpc.Service"));
const _67 = __importStar(require("./bank/v1beta1/tx.rpc.msg"));
var cosmos;
(function (cosmos) {
    let bank;
    (function (bank) {
        bank.v1beta1 = {
            ..._9,
            ..._10,
            ..._11,
            ..._12,
            ..._63,
            ..._64,
            ..._65,
            ..._67
        };
    })(bank = cosmos.bank || (cosmos.bank = {}));
    let base;
    (function (base) {
        let abci;
        (function (abci) {
            abci.v1beta1 = {
                ..._13
            };
        })(abci = base.abci || (base.abci = {}));
        let query;
        (function (query) {
            query.v1beta1 = {
                ..._14
            };
        })(query = base.query || (base.query = {}));
        base.v1beta1 = {
            ..._15
        };
    })(base = cosmos.base || (cosmos.base = {}));
    let crypto;
    (function (crypto) {
        crypto.ed25519 = {
            ..._16
        };
        crypto.multisig = {
            ..._17
        };
        crypto.secp256k1 = {
            ..._18
        };
    })(crypto = cosmos.crypto || (cosmos.crypto = {}));
    let tx;
    (function (tx) {
        let signing;
        (function (signing) {
            signing.v1beta1 = {
                ..._19
            };
        })(signing = tx.signing || (tx.signing = {}));
        tx.v1beta1 = {
            ..._20,
            ..._21,
            ..._66
        };
    })(tx = cosmos.tx || (cosmos.tx = {}));
})(cosmos = exports.cosmos || (exports.cosmos = {}));
//# sourceMappingURL=bundle.js.map